<template>
    <div>
        <!-- 平台用户管理 -->
        <el-card class="search-form-card">
            <el-form ref="form" :inline="true" :rules="rules" :model="form" class="search-form">
                <el-form-item label="用户名:">
                    <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item label="手机号:">
                    <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="性别">
                    <el-select v-model="form.sex" placeholder="请选择性别">
                        <el-option
                                v-for="item in genders"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户状态">
                    <el-select v-model="form.status" placeholder="请选择用户状态">
                        <el-option
                                v-for="item in enables"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item label="用户角色">-->
                    <!--<el-select v-model="form.roleIdList"  placeholder="请选择用户角色">-->
                        <!--<el-option v-for="item in roleData"-->
                                <!--:key="item.roleId"-->
                                <!--:label="item.roleName"-->
                                <!--:value="item.roleId">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
                <el-form-item>
                    <el-button type="primary" @click="submit">查询</el-button>
                    <el-button @click="reset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <el-card>
            <div slot="header">
                <router-link :to="{ path:'/userAdd', query:{ callback:request } }">
                    <el-button type="primary">创建</el-button>
                </router-link>
                <!--<p class="tpl-p">默认密码:{{defaultPassword}}</p>-->
            </div>
            <el-table :data="tableData" v-loading="loading">
                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-if="form.limit===10"> {{form.page>1 ? scope.$index+1+(form.page-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.limit===20"> {{form.page>1 ? scope.$index+1+(form.page-1)*20 : scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="用户名" prop="username">
                    <!--<template slot-scope="scope">{{scope.row.username | transformVal(userList) }}</template>-->
                </el-table-column>
                <el-table-column label="性别" width="70">
                    <template slot-scope="scope">{{ getSex(scope.row.sex)}}</template>
                </el-table-column>
                <el-table-column label="邮箱" prop="email" minWidth="150"></el-table-column>
                <el-table-column label="手机号" prop="mobile" minWidth="110"></el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">{{ getStatus(scope.row.status)}}</template>
                </el-table-column>
                <el-table-column label="用户角色" prop="roleName"></el-table-column>
                <el-table-column label="创建时间" prop="createTime" minWidth="150"></el-table-column>
                <el-table-column label="操作" fixed="right" min-width="120">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/userAdd', query:{ type:'edit',params:scope.row, callback:request }}">
                            <el-button type="text">修改</el-button>
                        </router-link>
                        <!--<el-button class="table-del-btn" type="text" @click="userDelete(scope.row)">删除</el-button>-->
                        <!--<el-button type="text" @click="userPasswordReset(scope.row)" >重置密码</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="form.page"
                           :page-sizes="[10,20]"
                           :page-size="form.limit"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
    import { genders,enables,getSex,getStatus } from "./system.config"
    import services from "./system.service"
    export default {
        data() {
            return {
                rules:{},
                form:{
                    username: '',
                    sex:'',
                    mobile: null,
                    status: "",
                    roleIdList:'',
                    page: 1,
                    limit: 10,
                },
                total:null,
                loading:true,
                defaultPassword:"tyzh8888",
                roleData:[],
                tableData:[],
                userList:[],
                genders,enables,getSex,getStatus,
            }
        },
        created() {
            this.request();
            this.getRoleList();
            // this.getUserInfo() //获取所有用户信息，用于userid与name的转换
        },
        computed:{
            menuBar(){
                return this.$store.state.siteParam.menuBar;
            }
        },
        // filters:{
        //     transformVal(value,arr){
        //         if(!arr) return '无';
        //         if(arr && arr.length == 0) return "无";
        //         let res = arr.filter(item => item.userid == value)
        //         if(!res.length) return '无'
        //         return res[0].name;
        //     }
        // },
        methods: {
            getRoleList(){
                let menuBar = this.menuBar;
                services.getRoleList({ menuBar:menuBar }).then(res => {
                    res = res.filter(item => item.menuBar == menuBar);
                    this.roleData = res;
                })
            },
            // getUserInfo(){
            //     let userInfoParams={
            //             pageIndex:1,
            //             pageSize:10,
            //             keyword:""
            //         };
            //     services.getUserInfo(userInfoParams).then(res=>{
            //         this.userList=res.list
            //         console.log(this.userList);
            //     })
            // },
            submit(){
                this.form.page = 1;
                this.form.limit = 10;
                this.request();
            },
            reset(){
                this.form = {
                    username: '',
                    sex:'',
                    mobile: null,
                    status: "",
                    roleIdList: [],
                    page: 1,
                    limit: 10,
                };
                this.request();
            },
            request(){
                this.tableData = [];
                this.loading = true;
                let menuBar = this.menuBar;
                services.getUserList(this.form).then(res => {
                    res.list.forEach(r => {
                        if(r.roleEntityList && r.roleEntityList.length > 0){
                            r.roleEntityList = r.roleEntityList.filter(item => item.menuBar == menuBar );
                        }
                    });
                    res.list.forEach(r => {
                        if(r.roleEntityList && r.roleEntityList.length > 0){
                            let length=r.roleEntityList.length
                            r.roleName = r.roleEntityList[length-1].roleName;
                            r.roleId = r.roleEntityList[length-1].roleId;
                        }
                    })
                    this.tableData = res.list;
                    // console.log(this.tableData);
                    this.total = res.totalCount;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            userDelete(row){
                // console.log(row);
                let arr=[]
                arr.push(row.userId)
                // console.log(arr);
                this.openMessage('该帐号可能在多个业务系统中使用，您确定要删除该用户吗？', '删除', () => {
                    services.deleteUser(arr).then(() => {
                        this.$message.success("删除成功")
                        this.request();
                    }).catch(err => {
                        this.$message.error(err.message)
                    })
                });
            },
            userPasswordReset(row){
                this.openMessage('您确定要将该用户重置为默认密码吗？', '确定', () => {
                    services.resetUserPassword(row).then(() => {
                        this.$message.success("密码重置成功")
                    }).catch(err  => {
                        this.$message.error(err.message)
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                }).catch(() => {
                });
            },
            handleSizeChange(val){
                this.form.limit = val;
                this.request()
            },
            handleCurrentChange(val){
                this.form.page = val;
                this.request();
            },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
